import './LoginPage.less';

import { KeyOutlined, MailOutlined, SafetyOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input } from 'antd';
import React, { useContext, useEffect } from 'react';

import { AuthContext } from '../contexts/authContext';

const LoginPage = () => {
  const {
    cancelOtp,
    confirmOtp,
    isLoading,
    loginError,
    otpDestination,
    otpPending,
    signInWithEmail,
  } = useContext(AuthContext);

  // Enter still submits while the button shows its spinner, and every extra
  // request counts toward Cognito's lockout.
  const onFinish = (values) => {
    !isLoading && signInWithEmail && signInWithEmail(values);
  };

  const onOtpFinish = ({ code }) => {
    !isLoading && confirmOtp && confirmOtp(code);
  };

  const [form] = Form.useForm();
  const [otpForm] = Form.useForm();

  const tailLayout = {
    wrapperCol: { span: 24 },
  };

  // The code field is left as typed: clearing it lets browser code autofill
  // refill and resubmit it, burning attempts.
  useEffect(() => {
    if (loginError && !otpPending) {
      form.resetFields();
    }
  }, [loginError, otpPending, form]);

  const domainLogo = () => {
    if (window.location.host === 'www.carshippingrates.ca') {
      return '/assets/images/logo_csr.png';
    } else {
      return '/assets/images/logo_blue.png';
    }
  };

  const errorMessage = loginError && (
    <div className="login-page__error" role="alert">
      {loginError}
    </div>
  );

  return (
    <div className="login-page">
      <div className="login-page__header">
        <img alt="Logo" src={domainLogo()} />
      </div>

      {otpPending ? (
        <Form
          form={otpForm}
          name="otp-form"
          wrapperCol={{
            span: 24,
          }}
          onFinish={onOtpFinish}
        >
          <p className="login-page__hint">
            Enter the code from the most recent email sent to{' '}
            {otpDestination || 'your email'}.
          </p>
          <Form.Item
            name="code"
            rules={[
              {
                message: 'Please enter the 6-digit code!',
                pattern: /^\d{6}$/,
                required: true,
              },
            ]}
          >
            <Input
              autoFocus
              autoComplete="one-time-code"
              inputMode="numeric"
              maxLength={6}
              placeholder="Verification code"
              prefix={<SafetyOutlined />}
            />
          </Form.Item>

          {errorMessage}
          <Form.Item {...tailLayout}>
            <Button
              htmlType="submit"
              loading={isLoading}
              style={{ width: '100%' }}
              type="primary"
            >
              Verify
            </Button>
          </Form.Item>
          <Button
            disabled={isLoading}
            style={{ width: '100%' }}
            type="link"
            onClick={cancelOtp}
          >
            Back
          </Button>
        </Form>
      ) : (
        <Form
          form={form}
          initialValues={{ remember: true }}
          name="login-form"
          wrapperCol={{
            span: 24,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[{ message: 'Please input your username!', required: true }]}
          >
            <Input placeholder="Email" prefix={<MailOutlined />} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ message: 'Please input your password!', required: true }]}
          >
            <Input.Password placeholder="Password" prefix={<KeyOutlined />} />
          </Form.Item>

          <Form.Item {...tailLayout} name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          {errorMessage}
          <Form.Item {...tailLayout}>
            <Button
              htmlType="submit"
              loading={isLoading}
              style={{ width: '100%' }}
              type="primary"
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};

export default LoginPage;
